import React from "react";
import { t } from "ttag";

import { SplitContentCarouselBlock } from "@reactivated";

import { LongButton } from "../Clickables";
import { H, HLevel } from "../Headings";
import { RichText } from "../RichText";
import { SplitCarousel } from "../SplitCarousel";

import styles from "./SplitContentCarousel.module.scss";

export const SplitContentCarousel = ({
    value,
}: {
    value: SplitContentCarouselBlock;
}) => (
    <HLevel>
        <SplitCarousel
            slides={value.slides ?? []}
            showGraphic={value.show_graphic}
            moduleTheme={value.module_theme}
            cardTheme={value.card_color_theme}
            ariaLabel={t`Split content`}
            renderTextPanel={(slide) => (
                <>
                    {slide.eyebrow && (
                        <p className={styles.eyebrow}>{slide.eyebrow}</p>
                    )}
                    <H className={styles.headline}>{slide.headline}</H>
                    {slide.body && (
                        <div className={styles.body}>
                            <RichText value={slide.body} />
                        </div>
                    )}
                    {slide.cta?.display_name && (
                        <div className={styles.cta}>
                            <LongButton
                                variant="secondary"
                                simpleLink={slide.cta}
                            />
                        </div>
                    )}
                </>
            )}
        />
    </HLevel>
);
